export default __webpack_public_path__ + "static/ai-consultancy-1-188f00d2c7a9ee7864683c81ce18ee77.png";